import { Stack } from "@twilio-paste/core/stack";
import { Box } from "@twilio-paste/core/box";
import { Button } from "@twilio-paste/core/button";
import { Card } from "@twilio-paste/core/card";
import { ChatIcon } from "@twilio-paste/icons/esm/ChatIcon";
import { useWiseOwlContext } from "../../../hooks";

import {
  SupportCtaBlock,
  SupportCtaChannel,
} from "@twiliointernal/e2-commons-shared-definitions";
import { copy } from "../definitions";

interface SupportCtaRendererProps {
  block: SupportCtaBlock;
}

interface ChatSupportCalloutProps {
  message: string;
  linkText: string;
}

const ChatSupportCallout = ({ message, linkText }: ChatSupportCalloutProps) => {
  const {
    handlers: { handleToggleLiveChatPreEngagement },
  } = useWiseOwlContext();

  return (
    <Box as="div" paddingY="space30">
      <Card padding="space60">
        <Stack orientation={"horizontal"} spacing="space40">
          <ChatIcon decorative />
          <Box as="span">{message}</Box>
          <Button onClick={handleToggleLiveChatPreEngagement} variant="link">
            {linkText}
          </Button>
        </Stack>
      </Card>
    </Box>
  );
};

const SupportCtaRenderer = ({ block }: SupportCtaRendererProps) => {
  const {
    values: { channel },
  } = block;
  switch (channel) {
    case SupportCtaChannel.LiveChat:
      return (
        <ChatSupportCallout
          message={copy.supportCta.chat.ctaText}
          linkText={copy.supportCta.chat.message}
        />
      );
    default:
      return null;
  }
};

export default SupportCtaRenderer;
